import { Button, Text } from '@react-spectrum/s2';
import { style } from '@react-spectrum/s2/style' with { type: 'macro' };

export type ImageReplaceErrorType =
	| 'invalid_format'
	| 'file_too_large'
	| 'upload_failure'
	| 'slide_moved';

interface ImageReplaceErrorProps {
	errorType: ImageReplaceErrorType;
	onTryAgain: () => void;
	onCancel: () => void;
}

const ERROR_CONTENT: Record<
	ImageReplaceErrorType,
	{ title: string; subtitle: string; showTryAgain: boolean }
> = {
	invalid_format: {
		title: 'File format not supported',
		subtitle: 'Please upload your image as JPEG or PNG.',
		showTryAgain: false,
	},
	file_too_large: {
		title: 'Exceeds size limit',
		subtitle: 'Please upload a file smaller than 30 MB.',
		showTryAgain: false,
	},
	upload_failure: {
		title: 'Upload failed',
		subtitle: 'Please try again.',
		showTryAgain: true,
	},
	slide_moved: {
		title: 'This slide moved',
		subtitle: 'A repair changed the carousel. Pick your photo again.',
		showTryAgain: true,
	},
};

export const ImageReplaceError = ({
	errorType,
	onTryAgain,
	onCancel,
}: ImageReplaceErrorProps) => {
	const { title, subtitle, showTryAgain } = ERROR_CONTENT[errorType];

	return (
		<div
			className="absolute inset-0 flex flex-col items-center justify-center
				gap-4 rounded-2xl bg-white"
		>
			<div className="flex flex-col items-center gap-4">
				<Text
					styles={style({
						font: 'heading',
						color: 'heading',
						fontSize: 'heading-lg',
						fontWeight: 'bold',
					})}
				>
					{title}
				</Text>
				<Text
					styles={style({
						font: 'body',
						color: 'body',
						fontSize: 'body',
					})}
				>
					{subtitle}
				</Text>
			</div>
			<div className="flex gap-3">
				{showTryAgain ? (
					<>
						<Button variant="primary" onPress={onTryAgain}>
							<Text
								styles={style({
									fontWeight: 'bold',
									fontSize: 'body-sm',
								})}
							>
								Try again
							</Text>
						</Button>
						<Button variant="secondary" onPress={onCancel}>
							<Text
								styles={style({
									fontWeight: 'bold',
									fontSize: 'body-sm',
								})}
							>
								Cancel
							</Text>
						</Button>
					</>
				) : (
					<Button variant="primary" onPress={onCancel}>
						<Text
							styles={style({
								fontWeight: 'bold',
								fontSize: 'body-sm',
							})}
						>
							Ok
						</Text>
					</Button>
				)}
			</div>
		</div>
	);
};
